// extracted by mini-css-extract-plugin
export default {"button":"ConfirmCareProvider_button__j+Pa-","label":"ConfirmCareProvider_label__Qco3g","InfoMessage":"ConfirmCareProvider_InfoMessage__aVkdl"};